import BaseData from './BaseData';
import Factor from './Factor';
import Filter from './Filter';

/** 
 *  Type Data spécifique aux fonctions Evolution et Benchmarking
 *  @todo Séparer en EvolutionData et BenchmarkingData si besoin d'avoir des propriétés différentes entre les 2 fonctions + changer la déclaration du composant dans Evolution.vue et Benchmarking.vue
 *  */
class Data extends BaseData {
    /** Synthèse */
    Synthesis: string = null;
    /** Flux Energétique */
    ConsumptionFlow: string = null;
    /** Flux Financier */
    FinancialFlow: string = null;
    /** Types de données */
    Type: string = null;
    /** Liste des natures de relevé */
    NatureStatements: string[] = [];
    /** Type d'emetteur */
    IssuerType: string = null;
    /** Détermine si on utilise la date de facturation ou de paiement pour le type de synthese Budget */
    UsePaymentDate: boolean = false;
    /** Répartition sélectionnée */
    Distribution: string = "None";
    //#region Filtres
    /** Liste des filtres sélectionnés */
    Filters : Filter[] = [];
    /** Chaine correspondant à la formule du code budget */
    FilterBudgetModel: string = "";
    /** Chaine des identifiants des contrats sélectionnés */
    FilterContracts: string = "";
    /** Chaine des identifiants des coûts sélectionnés */
    FilterCostDetails: string = "";
    /** Energies sélectionnées */
    FilterExpendables: string = null;
    /** Chaine des identifiants des fournisseur sélectionnés */
    FilterProviders: string = "";
    /** Chaine des identifiants des vocations sélectionnées */
    FilterPurposes: string = "";
    /** Chaine des identifiants des tarifs sélectionnés */
    FilterTariffs: string = "";
    /** Chaine des identifiants des usages sélectionnés */
    FilterUsages: string = "";
    /** Chaine des identifiants des propriétaires sélectionnés */
    FilterOwner: string = "";
    /** Chaine des identifiants des payeurs factures sélectionnées */
    FilterPayingInvoice: string = "";
    /** Chaine des identifiants des titulaire d'abonnement sélectionnés */
    FilterSubscriptionHolder: string = "";
    /** Chaine des identifiants des types d'objet sélectionnés */
    FilterObjectType: string = "";
    /** Identifiant de la nomenclature sélectionnée */
    BudgetModelId: number = 0;
    //#endregion Filtres
    //#region Options Avancées
    /** ??? */
    Correctors: string = "";
    /** Indique si on prend en compte la dernière année glissante */
    SlidingYear: boolean = false;
    /** Indique si on ne prend pas en compte les factures estimées */
    WithoutEstimated: boolean = false;
    /** Indique si on prend uniquement les factures comptabilisées */
    IsAccounting: boolean = false;
    //#endregion Options Avancées
    /** Liste des affectations par facteur */
    Factors: Factor[] = [];
    //#region Affichage
    /** Comparaison des données */
    Compare: boolean = false;
    /** Cumul des données */
    Cumulate: boolean = false;
    /** Dissociation des données */
    Dissociate: boolean = false;
    //#endregion Affichage
}

export default Data;